import { useSelector } from "react-redux"
import styled from "styled-components"
import EqualYukSide from "../frameYukSide/EqualYukSide"
import { useEffect } from "react"
import { getLoadList, getLoadListAdmin } from "../../../features/loadList/loadListSlice"
import { useDispatch } from "react-redux"
import YukColumnBtn from "../frameYukSide/YukColumnBtn"
import WideYukSide from "../frameYukSide/WideYukSide"

const Container = styled.div`
    width: ${({width}) => width};
    transition: 1s;
    position: relative;
`


const YukFrames = () => {

    const {frameState} = useSelector(state => state.jobList)
    const { loadList, isLoadingGetLoadlist } = useSelector((state) => state.loadList);
    const {aracBekleyenYukCheckedItem} = useSelector(state => state.jobList)
    const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
    const rld = JSON.parse(storage.getItem("rld"))
    const dispatch = useDispatch()

  useEffect(() => {
    const query = {
        currentPage:1,
        isParsiyel: 0,
      }
        dispatch(getLoadList(query))
  },[])

  return (
    <Container width={frameState === "equal" ? "50%" : frameState === "aracSide" ? "80px" : frameState === "yukSide" && "calc(100% - 110px)"  }>
        {
            frameState === "equal" &&
            <EqualYukSide loadList={loadList} isLoading={isLoadingGetLoadlist} checkedItem={aracBekleyenYukCheckedItem}/>
        }
        {
            frameState === "yukSide" &&
            <WideYukSide loadList={loadList} isLoading={isLoadingGetLoadlist} checkedItem={aracBekleyenYukCheckedItem}/>
        }
        {
            frameState === "aracSide" &&
            <YukColumnBtn/>
        }
    </Container>
  )
}

export default YukFrames